

  <div class="tabs">
    <ng-container *ngFor="let tab of tabs">
      <button *ngIf="tab.Visible" class="q-btn tab-button" [ngClass]="{'tab-select': tab.Active}" (click)="ActiveTab(tab.Type)" [disabled]="tab.Locked"><i [ngClass]="tab.Font"></i>{{tab.Name}}</button>
    </ng-container>
  </div>

  <!-- Onglet de gestion de l'acces à l'extranet -->
  <div class="w-100">
    <queoval-stage-portail-extranet *ngIf="tabs[0].Visible" [ngClass]="{'d-none': !tabs[0].Active }" class="col-12"></queoval-stage-portail-extranet>
  </div>


  <!-- Onglet des questionnaires  -->
  <div class="w-100">
    <queoval-stage-questionnaires *ngIf="tabs[1].Visible" [ngClass]="{'d-none': !tabs[1].Active }" class="col-12"></queoval-stage-questionnaires>
  </div>

  <!-- Onglet du digital learning -->
  <div class="w-100">
    <queoval-stage-digital-learning *ngIf="tabs[2].Visible" [ngClass]="{'d-none': !tabs[2].Active }" class="col-12"></queoval-stage-digital-learning>
  </div>




